import type {
  PartnerPackagingV2,
  PartnerPackagingV2Create,
  PartnerPackagingV2Update,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const packaging = {
  search: {
    queryKey: 'partner-management-service/packaging',
    configurationType: 'default' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<PartnerPackagingV2[]>(
        `/partner-management-proxy/api/v1/partners/packaging`,
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/packaging/id',
    configurationType: 'no-cache' as const,
    fn: async (packagingTypeId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerPackagingV2>(
        `/partner-management-proxy/api/v1/partners/packaging/${packagingTypeId}`,
      );

      return data;
    },
  },
  create: async (packaging: PartnerPackagingV2Create) => {
    const { data } = await GatewayAxiosClient.post<PartnerPackagingV2>(
      `/partner-management-proxy/api/v1/partners/packaging`,
      packaging,
    );

    return { data, invalidateQueryKeys: [['partner-management-service/packaging']] };
  },
  update: async ({ packagingTypeId, packaging }: { packagingTypeId: string; packaging: PartnerPackagingV2Update }) => {
    const { data } = await GatewayAxiosClient.put<PartnerPackagingV2>(
      `/partner-management-proxy/api/v1/partners/packaging/${packagingTypeId}`,
      packaging,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/packaging'],
        ['partner-management-service/packaging/id', packagingTypeId],
      ],
    };
  },
};
